import React, { useState, useEffect } from 'react';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import EditionsTable from './Table';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import {
  TableSelectStatusType,
  TableSelectionType,
} from '@/pages/intelligence/components/TableComponents/components/TableCheckbox';
import { TOPGAMENUM } from '@/pages/intelligence/pages/TopCharts/_config/topChartsConst';
import { handleTableDefaultSelectGames } from '@/pages/intelligence/utils/tableUtils';
import { useIntl } from 'umi';

const RetentionCurveCard = (props: any) => {
  const {
    resData,
    latestDay = '',
    unPublishedAppIdList = [],
    cardStatus,
    defaultSortDownHead,
    pageSortAttr,
    onTableSortChage,
    entityType
  } = props;
  const { formatMessage } = useIntl();

  const { isLoading, isError, isNoData } = cardStatus || {};
  const [tableData, setTableData] = useState<any[]>([]);
  const [lineData, setLineData] = useState<any>([]);
  // 宽表勾选的数据
  const [defaultSelectionGames, setDefaultSelectionGames] = useState<
    TableSelectionType[]
  >([]);
  const [tableSelection, setTableSelection] = useState<TableSelectionType[]>(
    [],
  );

  useEffect(() => {
    /**将数据排序后再赋值给表格和折线 */
    const sortData = sortTableByMetric({
      tableData: resData,
      sortParams: {
        ratioType: 0,
        sortVal: 'desc',
        sortMetric: defaultSortDownHead,
      },
      timeProperty: 'date',
      metricProperty: 'name',
      growthProperty: 'dod',
    });
    // /**以D2排序后赋值次序 */
    const newSortData = sortData?.map((item, idx) => {
      item.rank = idx + 1;
      return item;
    });

    setTableData(newSortData);
    const defaultCheckData = newSortData?.slice(0, 6);
    setLineData(defaultCheckData);

    /**默认选择第一页的前6作为表格全选展示 */
    const defaultGames = handleTableDefaultSelectGames(
      newSortData?.slice(0, TOPGAMENUM),
      'app_id',
    );
    setDefaultSelectionGames(defaultGames);
    setTableSelection(defaultGames);
  }, [resData]);

  //表格列表项选择事件回调
  const onTableCheckGame = (
    selectList: TableSelectionType[],
    checkStatus: TableSelectStatusType,
  ) => {
    /**处理折线图数据 TODO*/
    setLineData(selectList);
  };

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={formatMessage({ id: 'dbi_retention_curve' })}
        subTitle={'All of time'}
        iconList={[]}
      >
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }
  return (
    <CardSlotV2
      className="dbi-mobileGames-card-context"
      title={formatMessage({ id: 'dbi_retention_curve' })}
      subTitle={'All of time'}
      rightText={latestDay ? `${formatMessage({ id: 'dbi_detail_latest_date' })}: ${latestDay}` : ''}
      rightTip={latestDay ? formatMessage({ id: 'dbi_detail_latestdate_info' }) : ''}
      disableChartType={['bar', 'pie']}
      activeTab={'line'}
    >
      <div className="trends-card-line">
        <Visualis
          lineData={lineData}
          secondTitleRight={formatMessage({ id: 'dbi_lifetime_retention' })}
          lineSourceIcon={'Sensor Tower'} 
        />
      </div>
      <EditionsTable
        tableData={tableData}
        unPublishedAppIdList={unPublishedAppIdList}
        tableSelection={tableSelection}
        tableSelectionAll={defaultSelectionGames}
        onTableCheckGame={onTableCheckGame}
        defaultSortDownHead={defaultSortDownHead}
        pageSortAttr={pageSortAttr}
        onTableSortChage={onTableSortChage}
        entityType={entityType}
      />
    </CardSlotV2>
  );
};

export default RetentionCurveCard;
